// Puerto del dominio (repository abstracto) para la integración SARLAFT 4.0.
import { Observable } from 'rxjs';
import { SarlaftEvaluationInput, SarlaftEvaluationResult } from '../../interfaces/sarlaft/sarlaft.interface';

export abstract class SarlaftRepository {
  abstract startEvaluation(input: SarlaftEvaluationInput): Observable<SarlaftEvaluationResult>;
  abstract pollEvaluation(input: SarlaftEvaluationInput): Observable<SarlaftEvaluationResult>;
}
